import {SortDirectionEnum} from './sort-direction.enum';
import {SortField} from './sort.field';
export class PageMeta {
   total?: number = 0;
   perPage?: number = 15;
   page?: number = 0;
   pages?: number = 0;
   search?: string = '';
   sortBy?: string = 'id';
   sortDirection?: SortDirectionEnum = SortDirectionEnum.ASC;
   filters?: Map<string, any> = new Map<string, any>();
   sorts?: SortField[] = [];

    static getParams(pageMeta: PageMeta): string {
        const filtersMap = pageMeta.filters ?? new Map<string, any>();
        const filters = Array.from(filtersMap.entries())
            .map(([key, value]) => {
                const paramName = `filters[${key}]`;
                return `${encodeURIComponent(paramName)}=${encodeURIComponent(String(value))}`;
            })
            .join('&');

        return `total=${pageMeta.total ?? ''}&page=${pageMeta.page ?? 0}&perPage=${pageMeta.perPage ?? 15}&search=${pageMeta.search ?? ''}&sortBy=${pageMeta.sortBy ?? 'id'}&sortDirection=${pageMeta.sortDirection ?? '0'}&sort=${pageMeta.sorts?.map(s => s.field + ',' + s.direction).join(',') ?? []}&${filters}`;
    }
}
